import React from "react";
import { useNavigate } from "react-router-dom";
import { useDimensions } from "../Util";
import { BsFillHouseFill } from "react-icons/bs";

const DeveloperNote = ({showDevNote}) => {

    const {w,h} = useDimensions();
    const navigate = useNavigate();

    const btnClose = {
            padding: "5px",
            background: "#00ADB5",
            color: "#EEEEEE",
            border: "2px solid #EEEEEE",
            borderRadius: w > h ? w : h,
            fontSize: 1.75 * h,
            fontFamily: "Outfit",
            marginInline: "5px",
            cursor: "pointer",
            fontWeight:600,
            marginTop:2*h
    }

    const dp={
        width:w>h?10*h:10*h,
        height:w>h?10*h:10*h
    }

    const content = {
        textAlign:"justify",
        fontSize:w>h?"clamp(12px,1.25vw,14px)":"clamp(12px,1.25vh,14px)"
    }

    const handleclick=()=>{
        showDevNote(false);
    }

    return <div>
        <div style={{overflow:"float"}}>
            <img src={"/images/krrishdp.png"} style={dp} alt="Image" />
            <p style={content}>
                Hey, I’m the lead Developer of this app, but more importantly, your companion on this journey.
                I know you’ve probably come across countless methods, apps, and promises—"Do this, and you’ll quit." But let’s be real… if it were that simple, you wouldn’t be here right now. I’ve seen it firsthand—quick fixes don’t truly work. Not for my friends, not for the people I’ve helped, and likely not for you either.
                Because the truth is, there’s no one-size-fits-all solution. Every person is different. Every struggle is different. And that means the path to breaking free has to be your own.
                That’s why I’m here. Not to force you. Not to judge you. But to walk beside you. To help you figure out what works for you. Because quitting something that has its hooks in you isn’t just about stopping. It’s about choosing a better version of yourself—every single day.
                And that’s where ProAddictive comes in. It’s not just another app—it’s a system built to keep you accountable with two core features:
                    1. Penalty Jar – Each time you slip, you pay a fine. A real, tangible consequence for the choices you make.
                    2. Punishment Clock – Instead of giving in to cravings, you commit to an alternative activity—one that redirects your energy toward something meaningful. Next time the urge hits, you already have a plan in place.
                There are no shortcuts, no magic solutions—just real commitment, real action, and real change. And I’ll be here with you, every step of the way.
            </p> 
        </div>
        <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
            <button style={btnClose} onClick={handleclick}>close</button>
        </div>
    </div>
}

export default DeveloperNote;